import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 1rem 0.5rem;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;

  svg {
    fill: #4570b5;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;
export const MobileLogo = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }
  @media only screen and (min-width: 891px) {
    display: none;
  }
`;

export const WebLogo = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
  @media only screen and (min-width: 891px) {
    display: block;
    width: 170px;
  }
  @media only screen and (min-width: 1010px) {
    display: block;
    width: 280px;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #4570b5;
  transition: color 0.2s ease-in;
  margin: 0.5rem 1.5rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    color: #ffa500;
    text-underline-position: under;
    text-decoration: #ffa500 wavy underline;
  }
`;
export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 75px;
  border: 1px solid #4570b5;
  border-radius: 15px;
  padding: 1px;
`;
export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;
